export default "__VITE_ASSET__BZhWCzUn__"